/* eslint-disable react/destructuring-assignment */
import { PortfolioInfoDetail } from 'clientportalshared';
import Grid from '@mui/material/Grid';
import { useHistory } from 'react-router-dom';
import { numberFormatterDollar } from '@utils/GenericUtils';
import { holdingsUrl } from '@utils/UrlBuilder';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import Colors from '@src/app/config/colorConfig';
import { useAppDispatch } from '@src/app/hooks/store';
import { selectOnePortfolioByKey } from '@src/app/store/reducers/portfolios';
import { ChevronRight } from '@mui/icons-material';

export interface PortfolioCardProps extends PortfolioInfoDetail {
  singleItem?: boolean;
}

const PortfolioCard = (props: PortfolioCardProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const portfolioKey = props.portfolioKey!;
  const name = props.name!;
  const currentValue = props.currentValue || 0;
  const singleItem = props.singleItem!;

  const history = useHistory();

  const selectPortfolio = () => {
    dispatch(selectOnePortfolioByKey(portfolioKey));
  };

  const handleNavigation = () => {
    selectPortfolio();
    history.push(holdingsUrl());
  };

  return (
    <Grid item xs={12} lg={singleItem ? 12 : 6} onClick={handleNavigation} sx={{ ':hover': { cursor: 'pointer' } }}>
      <Card
        elevation={0}
        sx={{
          borderRadius: '13.85px',
          border: `1px solid ${Colors.gray300}`,
          boxShadow: '0px 1.84px 10.11px 1.84px #E4E4E4',
          minHeight: '100%',
        }}
      >
        <CardHeader
          title={name}
          titleTypographyProps={{
            fontWeight: 700,
            textTransform: 'uppercase',
            fontSize: 14,
            color: '#C1C1C1',
          }}
          action={<ChevronRight sx={{ color: '#D7D7D7' }} />}
        />
        <CardContent>
          <Typography fontWeight={700} fontSize={24}>
            {numberFormatterDollar(currentValue)}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

PortfolioCard.defaultProps = {
  singleItem: false,
};

export default PortfolioCard;
